<template>
    <div id="failed-edi-file-upload-filters-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Failed EDI File Uploads</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
                    <div class="container">
                        <div class="row">
                            <div class="d-flex justify-content-between mt-3 mb-1">
                                <label class="d-inline-flex my-auto mr-1">Failed Date Range</label>
                                <div class="d-inline-flex align-items-center">
                                    <input type="date" class="form-control form-control-sm" v-model="filters.beginDate">
                                    <span class="mx-1">To</span>
                                    <input type="date" class="form-control form-control-sm" v-model="filters.endDate">
                                </div>                                
                            </div>
                        </div>                                               
                    </div>                                       
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="done">Done</button>
                </div>                
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() { 
        return {
            filter: Function,
            filters: {
                beginDate: null,
                endDate: null
            },
            message: null
        }
    },
    methods: {
        show: function (filters, filter) {

            // make a copy of the filters and store the callback
            this.filters = JSON.parse(JSON.stringify(filters));
            this.filter = filter;

            $('#failed-edi-file-upload-filters-modal').modal('show');
        },
        reset: function () {
            this.filters.beginDate = null;
            this.filters.endDate = null;
            this.message = null;
        },
        done: function () {

            if (this.filters.beginDate <= this.filters.endDate) {
                this.filter(this.filters);
                $('#failed-edi-file-upload-filters-modal').modal('hide');
            }
            else { 
                this.message = 'Invalid date range. End date must be greater than or equal to begin data.';
            }
        }        
    },
    created() {
        eventHub.$on('show-failed-edi-file-upload-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-failed-edi-file-upload-filters');
    },
    watch: {
        'filters.beginDate': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.filters.endDate = newValue;
            }
        }
    }       
}
</script>

<style scoped>

</style>